import Drawer from 'components/utility/drawer'
import React, { useEffect, useRef, useState } from 'react'
import RequestQuestionnaire from '.'
import RequesterFlowCloseModal from './Modal/close_modal'

export default function RequestQuestionnaireDrawer({ show, onClose, ...props }) {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const [showCloseModal, setShowCloseModal] = useState(false)

  useEffect(() => {
    if (show) {
      setOpen(show)
    } else {
      setShowCloseModal(false)
      setOpen(false)
    }
  }, [show])

  const openCloseModal = () => setShowCloseModal(true)
  const handleClickOutsideDrawer = () => ref.current.onClose()

  return (
    <>
      <Drawer show={open} onClose={handleClickOutsideDrawer}>
        <Drawer.Content direction="right">
          <RequestQuestionnaire ref={ref} {...props} onClose={onClose} openCloseModal={openCloseModal} />
        </Drawer.Content>
      </Drawer>
      <RequesterFlowCloseModal onBack={() => setShowCloseModal(false)} open={showCloseModal} onClose={onClose} />
    </>
  )
}
